import { createContext, useContext } from 'react';

export const SystemNotificationsContext = createContext<any>(undefined);
export const useSystemNotificationsContext = () => useContext(SystemNotificationsContext);
